import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Offer {
  url: string;
  name: string;
  amount?: number;
  status?: 'pending' | 'completed' | 'rejected';
}

interface OfferState {
  activeOffers: Offer[];
  completedOffers: Offer[];
  currentOffer: Offer | null;
  selectedOfferId: string | null;
}

const initialState: OfferState = {
  activeOffers: [],
  completedOffers: [],
  currentOffer: null,
  selectedOfferId: null,
};

const offerSlice = createSlice({
  name: 'offer',
  initialState,
  reducers: {
    setActiveOffers: (state, action: PayloadAction<Offer[]>) => {
      state.activeOffers = action.payload;
    },
    setCompletedOffers: (state, action: PayloadAction<Offer[]>) => {
      state.completedOffers = action.payload;
    },
    setCurrentOffer: (state, action: PayloadAction<Offer | null>) => {
      state.currentOffer = action.payload;
    },
    setSelectedOfferId: (state, action: PayloadAction<string | null>) => {
      state.selectedOfferId = action.payload;
    },
    addCompletedOffer: (state, action: PayloadAction<Offer>) => {
      state.completedOffers.push(action.payload);
      state.activeOffers = state.activeOffers.filter(
        (offer) => offer.url !== action.payload.url
      );
    },
    clearOffers: (state) => {
      state.activeOffers = [];
      state.completedOffers = [];
      state.currentOffer = null;
      state.selectedOfferId = null;
    },
  },
});

export const {
  setActiveOffers,
  setCompletedOffers,
  setCurrentOffer,
  setSelectedOfferId,
  addCompletedOffer,
  clearOffers,
} = offerSlice.actions;

export default offerSlice.reducer;
